// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import ClassStep from "./class-step.js"
import CompetitionClassStep from "./competition-class-step.js"
import CompetitionSurvey from "./competition-survey.js"
import RequiredMetadatum from "./required-metadatum.js"
import Survey from "./survey.js"

const modelClassData = {
  "attributes": {
    "accessible_from": {
      "column": {
        "default": null,
        "name": "accessible_from",
        "null": true,
        "type": "datetime"
      },
      "name": "accessible_from",
      "selected_by_default": null,
      "translated": null
    },
    "accessible_to": {
      "column": {
        "default": null,
        "name": "accessible_to",
        "null": true,
        "type": "datetime"
      },
      "name": "accessible_to",
      "selected_by_default": null,
      "translated": null
    },
    "activated": {
      "column": null,
      "name": "activated",
      "selected_by_default": null,
      "translated": null
    },
    "allow_sign_out": {
      "column": {
        "default": true,
        "name": "allow_sign_out",
        "null": false,
        "type": "boolean"
      },
      "name": "allow_sign_out",
      "selected_by_default": null,
      "translated": null
    },
    "authenticate_anonymously": {
      "column": {
        "default": false,
        "name": "authenticate_anonymously",
        "null": false,
        "type": "boolean"
      },
      "name": "authenticate_anonymously",
      "selected_by_default": null,
      "translated": null
    },
    "authenticate_with_email": {
      "column": {
        "default": true,
        "name": "authenticate_with_email",
        "null": false,
        "type": "boolean"
      },
      "name": "authenticate_with_email",
      "selected_by_default": null,
      "translated": null
    },
    "authenticate_with_uni_c": {
      "column": {
        "default": true,
        "name": "authenticate_with_uni_c",
        "null": false,
        "type": "boolean"
      },
      "name": "authenticate_with_uni_c",
      "selected_by_default": null,
      "translated": null
    },
    "background_image_file_path": {
      "column": null,
      "name": "background_image_file_path",
      "selected_by_default": null,
      "translated": null
    },
    "deactivate_back_button": {
      "column": {
        "default": false,
        "name": "deactivate_back_button",
        "null": false,
        "type": "boolean"
      },
      "name": "deactivate_back_button",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "max_team_members": {
      "column": {
        "default": 8,
        "name": "max_team_members",
        "null": false,
        "type": "integer"
      },
      "name": "max_team_members",
      "selected_by_default": null,
      "translated": null
    },
    "min_team_members": {
      "column": {
        "default": 4,
        "name": "min_team_members",
        "null": false,
        "type": "integer"
      },
      "name": "min_team_members",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "no_class_step_presence_restriction": {
      "column": {
        "default": false,
        "name": "no_class_step_presence_restriction",
        "null": false,
        "type": "boolean"
      },
      "name": "no_class_step_presence_restriction",
      "selected_by_default": null,
      "translated": null
    },
    "pre_survey_id": {
      "column": {
        "default": null,
        "name": "pre_survey_id",
        "null": true,
        "type": "uuid"
      },
      "name": "pre_survey_id",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "activated",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "tenant_id": {
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      },
      "name": "tenant_id",
      "selected_by_default": null,
      "translated": null
    },
    "sign_in_image_path": {
      "column": null,
      "name": "sign_in_image_path",
      "selected_by_default": false,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "Competition",
  "collectionKey": "competitions",
  "collectionName": "competitions",
  "i18nKey": "competition",
  "camelizedLower": "competition",
  "name": "Competition",
  "nameDasherized": "competition",
  "pluralName": "competitions",
  "ransackable_associations": [
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "background_image_file_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "background_image_file_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "background_image_file_attachment"
    },
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_steps",
      "macro": "has_many",
      "resource_name": "ClassStep",
      "through": "competition_class_steps"
    },
    {
      "className": "CompetitionClassStep",
      "collectionName": "competition_class_steps",
      "foreignKey": "competition_id",
      "name": "competition_class_steps",
      "macro": "has_many",
      "resource_name": "CompetitionClassStep",
      "through": null
    },
    {
      "className": "CompetitionSurvey",
      "collectionName": "competition_surveys",
      "foreignKey": "competition_id",
      "name": "competition_surveys",
      "macro": "has_many",
      "resource_name": "CompetitionSurvey",
      "through": null
    },
    {
      "className": "HighscoreCompetition",
      "collectionName": "highscore_competitions",
      "foreignKey": "competition_id",
      "name": "highscore_competitions",
      "macro": "has_many",
      "resource_name": "HighscoreCompetition",
      "through": null
    },
    {
      "className": "HighscoreGenerationSurvey",
      "collectionName": "highscore_generation_surveys",
      "foreignKey": "competition_id",
      "name": "highscore_generation_surveys",
      "macro": "has_many",
      "resource_name": "HighscoreGenerationSurvey",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "participants",
      "macro": "has_many",
      "resource_name": "User",
      "through": "team_users"
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "pre_survey_id",
      "name": "pre_survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    },
    {
      "className": "RequiredMetadatum",
      "collectionName": "required_metadata",
      "foreignKey": "resource_id",
      "name": "required_metadatum",
      "macro": "has_one",
      "resource_name": "RequiredMetadatum",
      "through": null
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "sign_in_image_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "sign_in_image_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "sign_in_image_attachment"
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "surveys",
      "macro": "has_many",
      "resource_name": "Survey",
      "through": "competition_surveys"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "TeamApplication",
      "collectionName": "team_applications",
      "foreignKey": "team_id",
      "name": "team_applications",
      "macro": "has_many",
      "resource_name": "TeamApplication",
      "through": "teams"
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_id",
      "name": "team_surveys",
      "macro": "has_many",
      "resource_name": "TeamSurvey",
      "through": "teams"
    },
    {
      "className": "TeamUser",
      "collectionName": "team_users",
      "foreignKey": "team_id",
      "name": "team_users",
      "macro": "has_many",
      "resource_name": "TeamUser",
      "through": "teams"
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "competition_id",
      "name": "teams",
      "macro": "has_many",
      "resource_name": "Team",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "UserStep",
      "collectionName": "user_steps",
      "foreignKey": "team_survey_id",
      "name": "user_steps",
      "macro": "has_many",
      "resource_name": "UserStep",
      "through": "team_surveys"
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "accessible_from",
      "column": {
        "default": null,
        "name": "accessible_from",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "accessible_to",
      "column": {
        "default": null,
        "name": "accessible_to",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "allow_sign_out",
      "column": {
        "default": true,
        "name": "allow_sign_out",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "authenticate_anonymously",
      "column": {
        "default": false,
        "name": "authenticate_anonymously",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "authenticate_with_email",
      "column": {
        "default": true,
        "name": "authenticate_with_email",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "authenticate_with_uni_c",
      "column": {
        "default": true,
        "name": "authenticate_with_uni_c",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "competition_class_steps_count",
      "column": {
        "default": 0,
        "name": "competition_class_steps_count",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "deactivate_back_button",
      "column": {
        "default": false,
        "name": "deactivate_back_button",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "deprecated_activated",
      "column": {
        "default": false,
        "name": "deprecated_activated",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "max_team_members",
      "column": {
        "default": 8,
        "name": "max_team_members",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "min_team_members",
      "column": {
        "default": 4,
        "name": "min_team_members",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "no_class_step_presence_restriction",
      "column": {
        "default": false,
        "name": "no_class_step_presence_restriction",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_pre_survey_id",
      "column": {
        "default": null,
        "name": "old_pre_survey_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "pre_survey_id",
      "column": {
        "default": null,
        "name": "pre_survey_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "activated",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_steps",
      "macro": "has_many",
      "resource_name": "ClassStep",
      "through": "competition_class_steps"
    },
    {
      "className": "CompetitionClassStep",
      "collectionName": "competition_class_steps",
      "foreignKey": "competition_id",
      "name": "competition_class_steps",
      "macro": "has_many",
      "resource_name": "CompetitionClassStep",
      "through": null
    },
    {
      "className": "CompetitionSurvey",
      "collectionName": "competition_surveys",
      "foreignKey": "competition_id",
      "name": "competition_surveys",
      "macro": "has_many",
      "resource_name": "CompetitionSurvey",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "pre_survey_id",
      "name": "pre_survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    },
    {
      "className": "RequiredMetadatum",
      "collectionName": "required_metadata",
      "foreignKey": "resource_id",
      "name": "required_metadatum",
      "macro": "has_one",
      "resource_name": "RequiredMetadatum",
      "through": null
    }
  ],
  "paramKey": "competition",
  "primaryKey": "id"
}

/** Frontend model for Competition. */
export default class Competition extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date | null} */
  accessibleFrom() {
    return this.readAttributeUnderscore("accessible_from")
  }

  /** @returns {boolean} */
  hasAccessibleFrom() {
    const value = this.accessibleFrom()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  accessibleTo() {
    return this.readAttributeUnderscore("accessible_to")
  }

  /** @returns {boolean} */
  hasAccessibleTo() {
    const value = this.accessibleTo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  activated() {
    return this.readAttributeUnderscore("activated")
  }

  /** @returns {boolean} */
  hasActivated() {
    const value = this.activated()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  allowSignOut() {
    return this.readAttributeUnderscore("allow_sign_out")
  }

  /** @returns {boolean} */
  hasAllowSignOut() {
    const value = this.allowSignOut()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  authenticateAnonymously() {
    return this.readAttributeUnderscore("authenticate_anonymously")
  }

  /** @returns {boolean} */
  hasAuthenticateAnonymously() {
    const value = this.authenticateAnonymously()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  authenticateWithEmail() {
    return this.readAttributeUnderscore("authenticate_with_email")
  }

  /** @returns {boolean} */
  hasAuthenticateWithEmail() {
    const value = this.authenticateWithEmail()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  authenticateWithUniC() {
    return this.readAttributeUnderscore("authenticate_with_uni_c")
  }

  /** @returns {boolean} */
  hasAuthenticateWithUniC() {
    const value = this.authenticateWithUniC()

    return this._isPresent(value)
  }

  /** @returns {any} */
  backgroundImageFilePath() {
    return this.readAttributeUnderscore("background_image_file_path")
  }

  /** @returns {boolean} */
  hasBackgroundImageFilePath() {
    const value = this.backgroundImageFilePath()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  deactivateBackButton() {
    return this.readAttributeUnderscore("deactivate_back_button")
  }

  /** @returns {boolean} */
  hasDeactivateBackButton() {
    const value = this.deactivateBackButton()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {number} */
  maxTeamMembers() {
    return this.readAttributeUnderscore("max_team_members")
  }

  /** @returns {boolean} */
  hasMaxTeamMembers() {
    const value = this.maxTeamMembers()

    return this._isPresent(value)
  }

  /** @returns {number} */
  minTeamMembers() {
    return this.readAttributeUnderscore("min_team_members")
  }

  /** @returns {boolean} */
  hasMinTeamMembers() {
    const value = this.minTeamMembers()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  noClassStepPresenceRestriction() {
    return this.readAttributeUnderscore("no_class_step_presence_restriction")
  }

  /** @returns {boolean} */
  hasNoClassStepPresenceRestriction() {
    const value = this.noClassStepPresenceRestriction()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  preSurveyId() {
    return this.readAttributeUnderscore("pre_survey_id")
  }

  /** @returns {boolean} */
  hasPreSurveyId() {
    const value = this.preSurveyId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {string} */
  tenantId() {
    return this.readAttributeUnderscore("tenant_id")
  }

  /** @returns {boolean} */
  hasTenantId() {
    const value = this.tenantId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  signInImagePath() {
    return this.readAttributeUnderscore("sign_in_image_path")
  }

  /** @returns {boolean} */
  hasSignInImagePath() {
    const value = this.signInImagePath()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  chooseTeamsCollection(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "choose_teams_collection",
        primaryKey: this.primaryKey(),
        collectionName: "competitions",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  individualTeamForUser(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "individual_team_for_user",
        primaryKey: this.primaryKey(),
        collectionName: "competitions",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  startIndividually(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "start_individually",
        primaryKey: this.primaryKey(),
        collectionName: "competitions",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  teamsForUser(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "teams_for_user",
        primaryKey: this.primaryKey(),
        collectionName: "competitions",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./class-step.js").default>} */
  classSteps() {
    return new Collection(
      {
        reflectionName: "class_steps",
        model: this,
        modelClass: ClassStep
      },
      {
        params: {
          through: {
            model: "Competition",
            id: this.primaryKey(),
            reflection: "class_steps"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./class-step.js").default>>} */
  loadClassSteps() {
    return this._loadHasManyReflection(
      {
        reflectionName: "class_steps",
        model: this,
        modelClass: ClassStep
      },
      {
        params: {
          through: {
            model: "Competition",
            id: this.primaryKey(),
            reflection: "class_steps"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./class-step.js").default>>} */
  ensureClassStepsLoaded() {
    return this.ensureAssociationLoaded("class_steps")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./competition-class-step.js").default>} */
  competitionClassSteps() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["competition_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "competition_class_steps",
        model: this,
        modelClass: CompetitionClassStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./competition-class-step.js").default>>} */
  loadCompetitionClassSteps() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["competition_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "competition_class_steps",
        model: this,
        modelClass: CompetitionClassStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./competition-class-step.js").default>>} */
  ensureCompetitionClassStepsLoaded() {
    return this.ensureAssociationLoaded("competition_class_steps")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./competition-survey.js").default>} */
  competitionSurveys() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["competition_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "competition_surveys",
        model: this,
        modelClass: CompetitionSurvey
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./competition-survey.js").default>>} */
  loadCompetitionSurveys() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["competition_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "competition_surveys",
        model: this,
        modelClass: CompetitionSurvey
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./competition-survey.js").default>>} */
  ensureCompetitionSurveysLoaded() {
    return this.ensureAssociationLoaded("competition_surveys")
  }

  /** @returns {import("./survey.js").default | null} */
  preSurvey() {
    return this._readBelongsToReflection({modelClass: Survey, reflectionName: "pre_survey"})
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  loadPreSurvey() {
    if (!("preSurveyId" in this)) throw new Error("Foreign key method wasn't defined: preSurveyId")

    const id = this.preSurveyId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "pre_survey",
        model: this,
        modelClass: Survey
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  ensurePreSurveyLoaded() {
    return this.ensureAssociationLoaded("pre_survey")
  }

  /** @returns {import("./required-metadatum.js").default | null} */
  requiredMetadatum() {
    return this._readHasOneReflection({modelClass: RequiredMetadatum, reflectionName: "required_metadatum"})
  }

  /** @returns {Promise<import("./required-metadatum.js").default | null>} */
  loadRequiredMetadatum() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["resource_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "required_metadatum",
        model: this,
        modelClass: RequiredMetadatum
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./required-metadatum.js").default | null>} */
  ensureRequiredMetadatumLoaded() {
    return this.ensureAssociationLoaded("required_metadatum")
  }
}
